import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  style?: CSSProperties;
}

export function IconOverview({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="1" y="1" width="6" height="6" rx="1" />
      <rect x="9" y="1" width="6" height="6" rx="1" />
      <rect x="1" y="9" width="6" height="6" rx="1" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </svg>
  );
}

export function IconWork({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="2" y="3" width="12" height="10" rx="1.5" />
      <path d="M5 3V2a1 1 0 011-1h4a1 1 0 011 1v1" />
      <path d="M5 8h6M5 11h4" />
    </svg>
  );
}

export function IconOrgs({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M2 13V5l6-3 6 3v8" />
      <rect x="6" y="9" width="4" height="4" />
      <path d="M4 7h1M11 7h1M4 10h1" />
    </svg>
  );
}

export function IconUsers({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="6" cy="5" r="2.5" />
      <path d="M1 13c0-2.761 2.239-4 5-4s5 1.239 5 4" />
      <path d="M11 3a2.5 2.5 0 010 5M15 13c0-2.761-1.343-4-3-4" />
    </svg>
  );
}

export function IconBilling({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="1" y="4" width="14" height="9" rx="1.5" />
      <path d="M1 7h14" />
      <path d="M4 10.5h2M10 10.5h2" />
    </svg>
  );
}

export function IconOps({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="8" cy="8" r="6.5" />
      <path d="M8 4v4l2.5 2.5" />
    </svg>
  );
}

export function IconInsights({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M1 12l4-4 3 3 4-6 3 2" />
      <path d="M1 14h14" />
    </svg>
  );
}

export function IconAudit({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="2" y="1" width="12" height="14" rx="1.5" />
      <path d="M5 5h6M5 8h6M5 11h3" />
    </svg>
  );
}

export function IconPlatform({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="8" cy="8" r="2" />
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41" />
    </svg>
  );
}

export function IconAdmin({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 1l1.5 3 3.5.5-2.5 2.5.5 3.5L8 9l-3 1.5.5-3.5L3 4.5 6.5 4z" />
      <path d="M5 12h6M6 14h4" />
    </svg>
  );
}

export function IconSearch({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="6.5" cy="6.5" r="4.5" />
      <path d="M10 10l3.5 3.5" />
    </svg>
  );
}

export function IconBell({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 1.5a5 5 0 00-5 5v2.5L1.5 11h13L13 9V6.5a5 5 0 00-5-5z" />
      <path d="M6.5 11a1.5 1.5 0 003 0" />
    </svg>
  );
}

export function IconChevronDown({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 6l4 4 4-4" />
    </svg>
  );
}

export function IconChevronRight({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M6 4l4 4-4 4" />
    </svg>
  );
}

export function IconClose({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M3 3l10 10M13 3L3 13" />
    </svg>
  );
}

export function IconMenu({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M2 4h12M2 8h12M2 12h12" />
    </svg>
  );
}

export function IconEllipsis({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="currentColor">
      <circle cx="3" cy="8" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="13" cy="8" r="1.5" />
    </svg>
  );
}

export function IconAlert({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 1L1 14h14L8 1z" />
      <path d="M8 6v3.5M8 11.5v.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconRefresh({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M13.5 3.5A6.5 6.5 0 014 13M2.5 12.5A6.5 6.5 0 0112 3" />
      <path d="M13.5 3.5V7M2.5 12.5V9" />
    </svg>
  );
}

export function IconFilter({ className = '', style }: IconProps) {
  return (
    <svg className={className} style={style} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M1.5 3h13M4 8h8M6.5 13h3" />
    </svg>
  );
}
